import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { JYoguiSharedModule } from '../../shared';

import {
    ReservationService,
    ReservationPopupService,
    ReservationComponent,
    ReservationDetailComponent,
    ReservationDialogComponent,
    ReservationPopupComponent,
    ReservationDeletePopupComponent,
    ReservationDeleteDialogComponent,
    ReservationUnlinkPopupComponent,
    ReservationUnlinkDialogComponent,
    reservationRoute,
    reservationPopupRoute,
    ReservationResolvePagingParams,
    ReservationUtilService,
    ReservationPayPopupComponent,
    ReservationPayDialogComponent
} from './';

let ENTITY_STATES = [
    ...reservationRoute,
    ...reservationPopupRoute,
];

@NgModule({
    imports: [
        JYoguiSharedModule,
        RouterModule.forRoot(ENTITY_STATES, { useHash: true })
    ],
    declarations: [
        ReservationComponent,
        ReservationDetailComponent,
        ReservationDialogComponent,
        ReservationDeleteDialogComponent,
        ReservationPopupComponent,
        ReservationDeletePopupComponent,
        ReservationUnlinkDialogComponent,
        ReservationUnlinkPopupComponent,
        ReservationPayPopupComponent,
        ReservationPayDialogComponent,
    ],
    entryComponents: [
        ReservationComponent,
        ReservationDialogComponent,
        ReservationPopupComponent,
        ReservationDeleteDialogComponent,
        ReservationDeletePopupComponent,
        ReservationUnlinkDialogComponent,
        ReservationUnlinkPopupComponent,
        ReservationPayPopupComponent,
        ReservationPayDialogComponent
    ],
    providers: [
        ReservationService,
        ReservationPopupService,
        ReservationResolvePagingParams,
        ReservationUtilService
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class JYoguiReservationModule { }



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/reservation/reservation.module.ts